import React, { useState, useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import { Panel, Home } from "./components";
import { Register } from "./components/Auth/Register";
import { Login, ForgotPassword } from "./components/Auth/Login";
import i18n from "./i18n/locales/config";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import {
  LeftSectionContextProvider,
  ScenarioContextProvider,
  AutomationContextProvider,
  ProfileContextProvider,
  LumpContextProvider,
  DeviceContextProvider,
  CameraContextProvider,
} from "./context";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import { DeviceMineProvider } from "./context/DeviceMineContext";

const App = () => {
  const theme = "light" || "dark";
  const [openModal, setopenModal] = useState(false);
  const toggle = () => {
    setopenModal(!openModal);
  };

  useEffect(() => {
    toggle();
  }, []);

  const clickH = () => {
    document.documentElement.requestFullscreen();
    toggle();
  };
  useEffect(() => {
    const lan = Cookies.get("language") ? Cookies.get("language") : "en";
    i18n.changeLanguage(lan);
    lan === "en"
      ? document.querySelector("body").classList.add("dirLTR")
      : document.querySelector("body").classList.remove("dirLTR");
  }, []);

  return (
    <>
      {/* <Modal isOpen={openModal} toggle={toggle} style={{ backgroundColor: 'white' }}>
        <ModalHeader toggle={toggle}></ModalHeader>
        <ModalBody style={{ textAlign: 'right' }}>
          آیا مایل به استفاده از برنامه به صورت تمام صفحه هستید؟
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={clickH}>بله</Button>{' '}
          <Button color="secondary" onClick={toggle}>خیر</Button>
        </ModalFooter>
      </Modal> */}

      <Provider store={store}>
        <div className={`${theme}`}>
          <div
            className="d-flex flex-wrap"
            style={{ height: "120vh", margin: "0px", background: "#FAFAFA" }}
          >
            <Switch>
              <Route exact path="/" component={Home} />
              <Route exact path="/login" component={Login} />
              <Route exact path="/register" component={Register} />
              <Route exact path="/forgotpassword" component={ForgotPassword} />
              <LeftSectionContextProvider>
                <ScenarioContextProvider>
                  <AutomationContextProvider>
                    <ProfileContextProvider>
                      <LumpContextProvider>
                        <DeviceMineProvider>
                          <DeviceContextProvider>
                            <CameraContextProvider>
                              <Route exact path="/panel" component={Panel} />
                            </CameraContextProvider>
                          </DeviceContextProvider>
                        </DeviceMineProvider>
                      </LumpContextProvider>
                    </ProfileContextProvider>
                  </AutomationContextProvider>
                </ScenarioContextProvider>
              </LeftSectionContextProvider>
            </Switch>
          </div>
          {/* <button class="add-button">Add to home screen</button> */}
        </div>
      </Provider>
    </>
  );
};

export default App;
